import * as Sentry from "@sentry/vue";
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 5 })

export const getClickID = async (setLoading, exp_data) => {

  function parseBool(value, defaultValue) {
    return (value == 'true' || value == 'false' || value === true || value === false) && JSON.parse(value) || defaultValue;
  }
  const campaignIds = {
    'default': "6569e30566e3190001ccb376",
  }
  const cookieDomain = window.location.hostname
  const cookieDuration = parseInt("90") || 30
  const registerViewOncePerSession = parseBool("false", false)
  let lastPaidClickAttribution = false
  let firstClickAttribution = false
  const attribution = "lastpaid"
  const referrer = document.referrer;
  if (attribution === 'lastpaid') {
    lastPaidClickAttribution = true
  }
  else if (attribution === 'firstclick')  {
    lastPaidClickAttribution = false
    firstClickAttribution = true
  }
  else if (attribution === 'lastclick')  {
    lastPaidClickAttribution = false
    firstClickAttribution = false
  }

  const ourCookie = getCookie('rtkclickid-store')
  let clickID;

  const urlParams = new URLSearchParams(window.location.search);
  const locSearch = window.location.search.substring(1)
  const rtkfbp = getCookie('_fbp');
  const rtkfbc = getCookie('_fbc');
  const rtkttclid= getCookie('ttclid');
  const pixelParams = "&" + locSearch+"&sub19="+rtkfbp+"&sub20="+rtkfbc
  if (rtkfbp != undefined) {
    localStorage.setItem("fbp", rtkfbp)
  }
  if (rtkfbc != undefined) {
    localStorage.setItem("fbc", rtkfbc)
  }
  if (rtkttclid != undefined) {
    localStorage.setItem("ttclid", rtkttclid)
  }

  let campaignID = urlParams.get('cmpid')
  if (!campaignID) {
    campaignID = campaignIds['default']
  }

  if (lastPaidClickAttribution) {
    if (campaignID != campaignIds['default']) {
      firstClickAttribution = false
    }
    if (campaignID == campaignIds['default']) {
      firstClickAttribution = true
    }
  }
  let initialSrc = `${process.env.VUE_APP_URL}/track.php/${campaignID}?format=json&referrer=${referrer}&experiment=${exp_data.exp_id}&variation=${exp_data.assignment}`;
  for (let i = 1; i <= 10; i++) {
    initialSrc = removeParam("sub" + i, initialSrc)
  };
  initialSrc = removeParam("cost", initialSrc);
  initialSrc = removeParam("ref_id", initialSrc);

  if (!urlParams.get('rtkcid')) {

    if (sessionStorage.getItem('rtkclickid') === 'undefined' || !sessionStorage.getItem('rtkclickid')) {
      try {

        const rawData = await fetchData(initialSrc + pixelParams);
        clickID = rawData.clickid;
        Sentry.addBreadcrumb({
          category: "clickID",
          message: "set clickID (empty store)" + clickID,
          level: "debug",
        });

        setSessionClickID(clickID);

        if (ourCookie === null || ourCookie === undefined || ourCookie === 'undefined' || !firstClickAttribution) {
          setCookie(clickID, cookieDomain, cookieDuration);
        }

        if (sessionStorage.getItem('viewOnce') !== '1') {
          await trackView(rawData.clickid, referrer);
        }

        if (registerViewOncePerSession) {
          sessionStorage.setItem('viewOnce', '1')
        }
        await setLoading(false)

        localStorage.setItem('b_click_time', parseInt(Date.now()/1000));
        // this.$store.commit('SET_CLICK_TIME', parseInt(Date.now()/1000));

        return clickID;

      } catch (error) {
        Sentry.addBreadcrumb({
          category: "clickID",
          message: "error " + error,
          level: "debug",
        })
        console.error(error)
      }
    } else {
      clickID = sessionStorage.getItem('rtkclickid');
      setLoading(false);
      if (ourCookie === null || ourCookie === undefined || ourCookie === 'undefined' || !firstClickAttribution) {
        setCookie(clickID, cookieDomain, cookieDuration);
      }

      if (sessionStorage.getItem('viewOnce') !== '1') {
        await trackView(clickID, referrer);
      }

      if (registerViewOncePerSession) {
        sessionStorage.setItem('viewOnce', '1')
      }

      return clickID
    }
  } else {
    clickID = urlParams.get('rtkcid')
    setLoading(false)
    if (ourCookie === null || ourCookie === undefined || ourCookie === 'undefined' || !firstClickAttribution) {
      setCookie(clickID, cookieDomain, cookieDuration);
    }

    if (sessionStorage.getItem('viewOnce') !== '1') {
      await trackView(clickID, referrer);
    }

    if (registerViewOncePerSession) {
      sessionStorage.setItem('viewOnce', '1')
    }

    setSessionClickID(clickID)

    return clickID
  }
}

function setSessionClickID(clickID) {
  sessionStorage.setItem('rtkclickid', clickID);
}

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

async function fetchData(url) {
  const response = await axios.get(url);
  Sentry.addBreadcrumb({
    category: "clickID",
    message: "clickid request sent",
    level: "debug",
  });
  return response.data;
}

async function trackView(clickID, referrer) {
  const viewUrl = `${process.env.VUE_APP_URL}/track.php/view?clickid=${clickID}&referrer=${referrer}`;
  await axios.get(viewUrl);
}

function setCookie(clickID, domain, duration){
  const cookieName = "rtkclickid-store"
  const cookieValue = clickID
  const expirationTime = 86400 * duration * 1000;
  const date = new Date()
  const dateTimeNow = date.getTime();
  date.setTime(dateTimeNow + expirationTime);
  const editedDate = date.toUTCString();
  document.cookie = cookieName+"="+cookieValue+"; expires="+editedDate+"; path=/; domain=" + domain
}

function removeParam(key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
    param, params_arr = [],
    queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (let i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
};


